import { KEY_REDUCER_LIBRARY } from "./constants";

const selectorHistory = (state) => state[KEY_REDUCER_LIBRARY];

export const selectorHistoryAllHistoryUserId = (state) => selectorHistory(state).allHistoryUserId;
export const selectorHistoryAllHistory = (state) => selectorHistory(state).allHistory;
export const selectorHistoryLastTimeOpenML = (state) => selectorHistory(state).lastTimeOpenML;
